
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"16","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.639 20c.842 0 1.307-.765 1.713-1.646L19.69 2.46c.204-.436.31-.823.31-1.162C20 .562 19.439 0 18.703 0c-.339 0-.726.107-1.172.31L1.655 7.65C.813 8.03 0 8.513 0 9.366c0 .93.89 1.336 2.033 1.336l7.038.03c.145 0 .203.057.203.212l.02 7.022c0 1.114.396 2.034 1.345 2.034z","fill":"#888","fill-rule":"nonzero"}})])
          )
        }
      }
    